/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_New_CreatingInputs */



/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {League_New_CreatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_new_creating = /** @type {((inputs?: League_New_CreatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_New_CreatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création en cours...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione in corso...")
	return /** @type {LocalizedString} */ ("Creating...")
});